module.exports = __webpack_public_path__ + "img/party-bell.84d3a9c3.svg";